// src/shared/utils/invoice.ts

// Helper to get lifecycle state from either naming convention
const getLifecycleState = (invoice: any): string | undefined => {
  return invoice.lifecycle_state ?? invoice.lifecycleState;
};

export const isDraft = (invoice: any): boolean => getLifecycleState(invoice) === 'draft';
export const isPaid = (invoice: any): boolean => getLifecycleState(invoice) === 'paid';
export const isDisputed = (invoice: any): boolean => getLifecycleState(invoice) === 'disputed';
export const isPaused = (invoice: any): boolean => getLifecycleState(invoice) === 'paused';
